import { ref } from '@vue/composition-api'
import draftApi from '@/services/api/drafts'
import EventBus from '@/store/EventBus'

export default function useDraftView() {
  const draft = ref(null)
  const loading = ref(false)
  const loadFailed = ref(false)

  async function loadDraft(id) {
    loading.value = true
    loadFailed.value = false
    try {
      const res = await draftApi.get(id)
      draft.value = res.data.data
    } catch (err) {
      loadFailed.value = true
      const data = err.response != null ? err.response.data : null
      const msg = data != null && data.message != null ? data.message : null
      if (msg) EventBus.$emit('http-error-persistent', msg)
    } finally {
      loading.value = false
    }
  }

  return { draft, loading, loadFailed, loadDraft }
}



// WEBPACK FOOTER //
// ./src/composables/drafts/useDraftView.js